import React, {memo, PropsWithChildren, ReactElement} from "react";
import { TinyArea } from "@ant-design/plots";
import { Empty } from "antd";
import {ISignatureItem} from "@Models/IActivityDetails";
import {clamp} from "@Utils";

export interface ILineChartProps<V> {
    values: ISignatureItem[];
    tooltipFormatter?: (value, field) => { name: string; value: string | number };
    tooltipTitle?: (value: string) => string;
    lineColor: string;
    fill: string;
}

function SignatureChart<V>(props: PropsWithChildren<ILineChartProps<V>>): ReactElement {

    const values: number[] = [];
    let firstTrackingId = -1;
    props.values.filter(x => x.metric == "dsj").forEach(x => {
        if (firstTrackingId == -1) firstTrackingId = x.trackingId;
        if (x.trackingId === firstTrackingId) {
            const items = props.values.filter(y => y.timeIndex == x.timeIndex).map(y => y.value);
            const sum = items.reduce((a, b) => a + b, 0);
            const avg = (sum / items.length) || 0;
            values.push(Math.sqrt(clamp(avg, 0, 1000)));    
        }
    });
    const max = Math.max(...values);
    
    const config = {
        data: values.map(x => Math.round((max - x) * 1000) / 1000),
        smooth: true,
        animate: false,
        padding: 0,
        connectNulls: false,
        lineStyle: {
            stroke: props.lineColor
        },
        areaStyle: () => {
            return {
                fill: props.fill,
            };
        },
    };

    if (props.values.length < 2) {
        return <Empty />;
    }

    return (
        <div style={{width:"100%", height:"60px"}}>
            <TinyArea {...config} />
        </div>
    );
}

export default memo(SignatureChart);
